/** Русское склонение по числу. Формы: 1 день / 2 дня / 5 дней.
 *
 * Вынесено, потому что успело появиться в двух местах с одинаковой логикой и
 * разными хвостами — а правило тут ровно одно и ошибиться в нём легко: 11–14
 * ведут себя как «много», хотя оканчиваются на 1–4.
 */
export function plural(n: number, forms: [string, string, string]): string {
  const rest = Math.abs(n) % 100;
  const last = rest % 10;
  if (rest > 10 && rest < 20) return `${n} ${forms[2]}`;
  if (last === 1) return `${n} ${forms[0]}`;
  if (last >= 2 && last <= 4) return `${n} ${forms[1]}`;
  return `${n} ${forms[2]}`;
}
